import { render } from "./EditTournament.vue?vue&type=template&id=526b9a2a&scoped=true&ts=true"
import script from "./EditTournament.vue?vue&type=script&lang=ts"
export * from "./EditTournament.vue?vue&type=script&lang=ts"

import "./EditTournament.vue?vue&type=style&index=0&id=526b9a2a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526b9a2a"]])

export default __exports__